import { ReactToolTip } from "components/ReactToolTip";


export interface IListOfSectorAndLocations {
  locationId: string;
  locationName: string;
  locationSectors: string[];
}
interface IGetUnitySectorsProps {
  elements: IListOfSectorAndLocations[]
  index: number
}
export const GetUnitySectors = ({ elements, index }: IGetUnitySectorsProps) => {
  return (<div data-tooltip-id={`${index}`}>
    <ReactToolTip id={`${index}`} variant="light" styles="bg-white" place="top-start">
      <LocationSectorToolTip elements={elements} />
    </ReactToolTip>
    {
      elements?.map((location, idx) => {
        return <div className="flex flex-col" key={location?.locationId || idx}>
          <div>
            <span className="font-bold text-xs text-textSelect">{location?.locationName}</span>
            {
              location?.locationSectors.length ? <>:&#160;
                <SectorElement locationSectors={location?.locationSectors} showExtra={true} sliceNumber={3} />
              </>
                : null
            }
          </div>
        </div>
      })
    }
  </div>)
}

export const SectorElement = ({ locationSectors, sliceNumber, showExtra }: { locationSectors: string[], sliceNumber: number, showExtra: boolean }) => {
  return <>
    {
      locationSectors?.slice(0, sliceNumber)?.map((sector, idx, array) => {
        const isLastElement = idx === array.length - 1;
        return <span key={idx} className="font-normal">
          {sector}
          {!isLastElement ? ', ' : ''}
        </span>
      })
    }
    {locationSectors?.length > 3 && showExtra ? `, +${locationSectors?.length - 3}` : ''}
  </>
}

export const LocationSectorToolTip = ({ elements }: { elements: IListOfSectorAndLocations[] }) => {
  return <div className="opacity-100 z-[99999]">
    {
      elements?.map((location, idx) => {
        return <div className="flex flex-col" key={location?.locationId || idx}>
          <div>
            <span className="font-bold text-xs text-textSelect">{location?.locationName}</span>
            {
              location?.locationSectors.length ? <>:&#160;
                <SectorElement locationSectors={location?.locationSectors} showExtra={false} sliceNumber={location?.locationSectors?.length} />
              </>
                : null
            }
          </div>
        </div>
      })
    }
  </div>
}